import script from "./MegaTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./MegaTitle.vue?vue&type=script&setup=true&lang=js"

import "./MegaTitle.vue?vue&type=style&index=0&id=519ec732&lang=scss"

const __exports__ = script;

export default __exports__